var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.canAccess)?_c('hand-box',{attrs:{"accessProvider":_vm.accessProv,"passTag":_vm.passTag},on:{"checkSuccess":_vm.handleCanAccess}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }